const disgustedFeelings = [
  'Ne pas préciser',
  'Dégouté.e',
  'Ecoeuré.e',
];

export default disgustedFeelings;
